import { useMemo } from 'react';

import { getAddressScannerUrl, maskAddressValue } from '@/utils/format';

import { EventTriggerType, Trigger } from '../../domain';
import { TriggerExternalLinkDetail } from './components/TriggerExternalLinkDetail';
import { TriggerType } from './components/TriggerType';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export const NadoTriggerDetails = ({ trigger, triggerType }: Props) => {
  const scannerUrl = useMemo(() => {
    if (!trigger.contracts?.[0]) return '';

    const contract = trigger.contracts[0];
    return getAddressScannerUrl('chainId', contract.chainId, contract.address) || '';
  }, [trigger.contracts]);

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />

      <TriggerExternalLinkDetail
        label="Contract"
        value={maskAddressValue(trigger.contracts?.[0]?.address ?? '') ?? ''}
        href={scannerUrl}
      />
    </div>
  );
};
